export default __webpack_public_path__ + "7535805.png";